import { LabelType, LabelGroup, } from '@wix/ambassador-inbox-labels-server/types';
export function isAssigneeLabel(label) {
    return (label.group === LabelGroup.ASSIGNEE && label.type === LabelType.USER_ID);
}
export var SYSTEM_LABELS_IDS;
(function (SYSTEM_LABELS_IDS) {
    SYSTEM_LABELS_IDS["UNASSIGNED"] = "10e089f2-1c4f-4db4-b1c4-b8ce552d120f";
})(SYSTEM_LABELS_IDS || (SYSTEM_LABELS_IDS = {}));
//# sourceMappingURL=labels.js.map